/*
 * @Author: caiqin.xie
 * @since: 2023-06-29 15:49:13
 * @lastTime: 2023-11-10 15:46:02
 * @LastEditors: caiqin.xie
 * @message: 线下门店-门店组件
 */
import React from "react";
import ShopItem from "../../../components/ShopItem";
import styles from "../../index.module.scss";
import { IShop } from "@/common/types";

interface IProps {
  shopList: IShop[]; // 门店列表
  allShopList: IShop[]; // 所有门店列表
  device: string;
}

const OfflineShopList = (props:IProps) => {
  const {shopList, allShopList, device} = props;
  const list = device === 'pc' ? shopList : allShopList

  return (
    <div className={styles['store-list']}>
      {list.map((shop:IShop) => (
        <ShopItem shopData={shop} className={styles['store-item']} key={shop.id} />
      ))}
    </div>
  )
}

export default OfflineShopList;
